import { render, staticRenderFns } from "./OptionItem.vue?vue&type=template&id=956f6a22&scoped=true&"
import script from "./OptionItem.vue?vue&type=script&lang=js&"
export * from "./OptionItem.vue?vue&type=script&lang=js&"
import style0 from "./OptionItem.vue?vue&type=style&index=0&id=956f6a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956f6a22",
  null
  
)

export default component.exports